import React from "react";
import Slider from '../../basic/slider';
import SlideContainer from './SlideContainer';

export default class Carousel extends React.Component {
    render() {
        const config = this.props.config;
        let respDOM = config.querySelector('resp');
        let noslid = respDOM && respDOM.dataset['noslid'] ? parseInt(respDOM.dataset['noslid']) : undefined;
        let resp = undefined;
        let children = [];
        
        if(config){
            let breakpoints = Array.from(config.querySelectorAll('resp>breakpoint'));
            if(breakpoints.length != 0){
                resp = breakpoints.map(b => { return { breakpoint: parseInt(b.dataset['value']), slidesToShow: parseInt(b.textContent) }} );
            }
            children = Array.from(config.querySelectorAll('slides>div'));
        }

        return (
            <Slider resp={resp} noslid={noslid} autoPlay={false} ref={dom => this.slider = dom}>
                {
                    children.map((child, index) => {
                        return (
                            <SlideContainer key={index} child={child} />
                        );
                    })
                }
            </Slider>
        )
    }
}
